var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2726 4.84402C24.677 5.43964 23.8321 5.63196 23.075 5.42097C22.7137 5.32014 22.372 5.12782 22.0882 4.84402C21.8044 4.56021 21.6121 4.21852 21.5113 3.85722C21.3003 3.10009 21.4926 2.25426 22.0882 1.65957C22.9676 0.780142 24.3941 0.780142 25.2736 1.65957C26.1521 2.53901 26.1521 3.96458 25.2726 4.84402Z",
    stroke: "#D42627",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0758 5.4221L21.0957 7.40222L19.531 5.83754L21.5111 3.85742C21.612 4.21872 21.8043 4.56041 22.0881 4.84422C22.3728 5.12896 22.7145 5.32127 23.0758 5.4221Z",
    stroke: "#D42627",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0936 10.8979L16.0346 5.83883C15.6005 5.40471 15.6005 4.7008 16.0346 4.26668L16.211 4.09023C16.6451 3.65612 17.3491 3.65612 17.7832 4.09023L22.8422 9.1493C23.2763 9.58342 23.2763 10.2873 22.8422 10.7215L22.6658 10.8979C22.2317 11.332 21.5278 11.332 21.0936 10.8979Z",
    stroke: "#D42627",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7888 6.59375L20.3392 10.1442L8.35392 22.1295C8.28764 22.1957 8.20362 22.2415 8.11119 22.2602L4.24897 23.0686C4.01931 23.1172 3.81486 22.9127 3.8634 22.6831L4.67188 18.8208C4.69149 18.7294 4.7363 18.6444 4.80258 18.5781L16.7888 6.59375Z",
    stroke: "#D42627",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.84402 1.65969C5.43964 2.25531 5.63196 3.1002 5.42097 3.85734C5.32014 4.21863 5.12782 4.56032 4.84402 4.84413C4.56021 5.12794 4.21852 5.32026 3.85722 5.42108C3.10009 5.63207 2.25426 5.43975 1.65957 4.84413C0.780142 3.9647 0.780142 2.53819 1.65957 1.65876C2.53901 0.780259 3.96458 0.780259 4.84402 1.65969Z",
    stroke: "#D42627",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42137 3.85742L7.40149 5.83754L5.83681 7.40222L3.85669 5.4221C4.21798 5.32127 4.55968 5.12896 4.84348 4.84515C5.12823 4.56041 5.32054 4.21872 5.42137 3.85742Z",
    stroke: "#D42627",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8984 5.83883L5.83932 10.8979C5.4052 11.332 4.70128 11.332 4.26717 10.8979L4.09072 10.7215C3.65661 10.2873 3.65661 9.58342 4.09072 9.1493L9.14979 4.09023C9.58391 3.65612 10.2878 3.65612 10.7219 4.09023L10.8984 4.26668C11.3325 4.7008 11.3325 5.40471 10.8984 5.83883Z",
    stroke: "#D42627",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1435 6.59335L6.59326 10.1436L8.35318 11.9035L11.9034 8.35327L10.1435 6.59335Z",
    stroke: "#D42627",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6835 23.0679L18.8213 22.2594C18.7298 22.2398 18.6448 22.195 18.5786 22.1287L15.0403 18.5904L18.5907 15.04L22.129 18.5783C22.1952 18.6446 22.241 18.7286 22.2597 18.821L23.0681 22.6833C23.1176 22.9129 22.9141 23.1164 22.6835 23.0679Z",
    stroke: "#D42627",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttack);
export default __webpack_public_path__ + "static/media/attack.2b1197f4ce089a9b03f205e4f000b189.svg";
export { ForwardRef as ReactComponent };